// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSearchOffersMobileSiteRequest,
  TSearchOffersMobileSiteModel,
  IMappers,
  TSearchOffersMobileSiteResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1SearchOffersForMobileSiteResponseSchema } from '../../entities/response/V1SearchOffersForMobileSiteResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSearchOffersMobileSiteModel(
  parameters: TSearchOffersMobileSiteRequest,
): TSearchOffersMobileSiteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-engine',
    pathApi: '/v1/search-offers-mobile-site/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchOffersMobileSiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchOffersMobileSiteRequest;
}

export async function fetchSearchOffersMobileSite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchOffersMobileSiteOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSearchOffersMobileSiteResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchOffersMobileSiteModel(parameters),
    config,
  )) as FetchResponse<TSearchOffersMobileSiteResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1SearchOffersForMobileSiteResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSearchOffersMobileSiteResponse>;
}
